import SuspendedQrTable from './suspendedQrTable.component';

export default SuspendedQrTable;